import cn from 'classnames'
import React, { ComponentProps } from 'react'
import { useTranslate } from 'src/localization/Trns'

type MccRestaurantsIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function MccRestaurantsIcon(props: MccRestaurantsIconProps) {
  const translate = useTranslate()
  const { className = '', ['aria-label']: ariaLabel, ...rest } = props
  return (
    <svg
      className={cn('MccRestaurantsIcon', className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={ariaLabel ?? translate('Restaurants')}
      {...rest}
    >
      <path
        d="M2 1.33325V5.99992C2 6.73325 2.6 7.33325 3.33333 7.33325H6C6.35362 7.33325 6.69276 7.19278 6.94281 6.94273C7.19286 6.69268 7.33333 6.35354 7.33333 5.99992V1.33325M4.66667 1.33325V14.6666M14 9.99992V1.33325C13.1159 1.33325 12.2681 1.68444 11.643 2.30956C11.0179 2.93468 10.6667 3.78253 10.6667 4.66659V8.66659C10.6667 9.39992 11.2667 9.99992 12 9.99992H14ZM14 9.99992V14.6666"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
